import {defineAsyncComponent} from 'vue';

// popup list
const AllocationDeliverListPopup = defineAsyncComponent(() =>
  import('@/views/allocationDeliver/AllocationDeliverListPopup.vue'),
);
// popup list
const AlcDelCheckImpListPopup = defineAsyncComponent(() =>
  import('@/views/allocationDeliver/AlcDelCheckImpListPopup.vue'),
);

const AllocationDeliverPtcDetailPopup = defineAsyncComponent(() =>
  import('@/views/allocationDeliver/AllocationDeliverPtcDetailPopup.vue'),
);

const AllocationDeliverSCQDetailPopup = defineAsyncComponent(() =>
  import('@/views/allocationDeliver/AllocationDeliverSCQDetailPopup.vue'),
);

const BaseAllocationDeliverPtcPopup = defineAsyncComponent(() =>
  import('@/views/allocationDeliver/ptc/BaseAllocationDeliverPtcPopup.vue'),
);


const BaseAllocationDeliverSCQPopup = defineAsyncComponent(() =>
  import('@/views/allocationDeliver/ptc/BaseAllocationDeliverSCQPopup.vue'),
);

const BaseAllocationDeliverAddAdjustSCQPopup = defineAsyncComponent(() =>
  import('@/views/allocationDeliver/ptc/BaseAllocationDeliverAddAdjustSCQPopup.vue'),
);

const BaseAllocationDeliverPtcCQPopup = defineAsyncComponent(() =>
  import('@/views/allocationDeliver/ptc/BaseAllocationDeliverPtcCQPopup.vue'),
);

const AllocationDeliverOrganizationPopup = defineAsyncComponent(() =>
  import('@/views/allocationDeliver/ptc/AllocationDeliverOrganizationPopup.vue')
);

export function allocationDeliverRegister(app) {
  app.component('AllocationDeliverListPopup', AllocationDeliverListPopup);
  app.component('AlcDelCheckImpListPopup', AlcDelCheckImpListPopup);
  app.component('AllocationDeliverOrganizationPopup', AllocationDeliverOrganizationPopup);
  app.component('AllocationDeliverPtcDetailPopup', AllocationDeliverPtcDetailPopup);
  app.component('AllocationDeliverSCQDetailPopup', AllocationDeliverSCQDetailPopup);
  app.component('BaseAllocationDeliverPtcPopup', BaseAllocationDeliverPtcPopup);
  app.component('BaseAllocationDeliverSCQPopup', BaseAllocationDeliverSCQPopup);
  app.component('BaseAllocationDeliverPtcCQPopup', BaseAllocationDeliverPtcCQPopup);
  app.component('BaseAllocationDeliverAddAdjustSCQPopup', BaseAllocationDeliverAddAdjustSCQPopup);
}
